import { writable } from 'svelte/store';

export const currentSection = writable('dashboard');
export const isAuthenticated = writable(false);
export const systemData = writable(null);
export const appsData = writable([]);
export const errorsData = writable([]);
export const safeModeActive = writable(false);
